import React, { useRef, useState, useEffect } from "react"
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import { IoCloseCircleOutline, IoArrowBackSharp } from "react-icons/io5";
import { IoMdArrowRoundBack } from "react-icons/io";
import { RiArrowRightUpLine } from "react-icons/ri";
import searchBarStyles from "./SearchBar.module.css"
import { getAllImagingPackageList } from "../../../../Redux/Actions";

export const SearchResultBar = ({ key, packageName, slug, focusedSearchResultRef, handleAccordionClose, handleAddressModalOpen, onOpenModal }) => {
  const history = useHistory();
  const city = useSelector((state) => state.cityOnTopNav.citySelect);

  const handleSearchResultItemClick = () => {

    // -----------Setting Recent Searches in Local Storage--------------
    let tmpRecentSearches = [];
    try {
      tmpRecentSearches = JSON.parse(localStorage.getItem("recentImagineSearches"));
      if (!tmpRecentSearches) {
        tmpRecentSearches = [];
      }
    }
    catch {
      tmpRecentSearches = [];
    }
    const recentSearchObj = {
      name: packageName,
      slug: slug,
    }
    let i = 0;
    while (i < tmpRecentSearches.length) {
      if (tmpRecentSearches[i].name === packageName) {
        break;
      }
      i++;
    }
    if (i !== tmpRecentSearches.length) {
      tmpRecentSearches.splice(i, 1);
    }
    tmpRecentSearches.unshift(recentSearchObj);
    localStorage.setItem("recentImagineSearches", JSON.stringify(tmpRecentSearches));
    // -------------------End-----------------------

    // -------------Pushing Slug To Router-----------------
    // handleAccordionClose
    // (handleAccordionClose)();
    handleAddressModalOpen(slug, "book");
    // router.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`);
    // setTimeout(() => {
    //   router.push(`/${slug}${city ? "-" + city.toLowerCase() : ""}`);
    // }, 500)
  }

  const searchResultItemMouseOver = (e) => {
    let focusedSearchResultItem = focusedSearchResultRef.current;
    focusedSearchResultItem.style.backgroundColor = "#fff";
    focusedSearchResultItem = e.currentTarget;
    focusedSearchResultItem.style.backgroundColor = "#f0f0f0";
    focusedSearchResultRef.current = focusedSearchResultItem
  }

  return (
    <div
      key={key}
      className={searchBarStyles.resultBar}
      onClick={onOpenModal}
      onMouseOver={searchResultItemMouseOver}
    >
      <RiArrowRightUpLine className={searchBarStyles.resultBarIcon} />
      <span className={searchBarStyles.resultBarName}>
        {packageName}
      </span>
    </div>
  )
}

const SearchBar = ({ searchValue, setSearchValue, handleAccordionClose, handleAddressModalOpen, onOpenModal }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const focusedSearchResultRef = useRef(null);

  const city = useSelector((state) => state.cityOnTopNav.citySelect);
  const packageSearchResult = useSelector((state) => state.getImgPackagesReducer?.ImgPackagesPageNation)
  const packagesList = packageSearchResult?.results ?? [];
  const [searchValueTimeoutId, setSearchValueTimeoutId] = useState(NaN);

  useEffect(() => {
    document.getElementById("search-accordion-input").scrollIntoView;
  }, [])

  // useEffect(() => {
  //   if (!window.matchMedia("(max-width: 480px)").matches) {
  //     document.getElementById("search-accordion-input").focus();
  //     console.log("focus search input");
  //   }
  // }, [])

  const handleBackClick = () => {
    history.goBack();
  }

  const handleSearchValueChange = (newSearchValue) => {
    focusedSearchResultRef.current = document.getElementById("search-results-container");

    if (!isNaN(searchValueTimeoutId)) {
      clearTimeout(searchValueTimeoutId);
    }

    if (newSearchValue !== "") {
      const timeoutId = setTimeout(() => {
        dispatch(getAllImagingPackageList(newSearchValue, city))
        setSearchValueTimeoutId(NaN);
      }, 300, newSearchValue, city)
      setSearchValueTimeoutId(timeoutId);
    }
    else {
      setSearchValueTimeoutId(NaN);
    }
    setSearchValue(newSearchValue);
  }

  const handleSearchResultFocus = (e) => {
    // console.log("focusedSearchResultRef", focusedSearchResultRef);
    if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) {
      if (packagesList.length === 0) {
        return
      }
      if (focusedSearchResultRef.current === document.getElementById("search-results-container")
        && e.keyCode === 40) {
        focusedSearchResultRef.current = document.getElementById("search-results-container").firstElementChild;
        focusedSearchResultRef.current.style.backgroundColor = "#f0f0f0";
        return;
      }
      let focusedSearchResultItem = focusedSearchResultRef.current;
      if (e.keyCode === 13) {
        focusedSearchResultItem.click();
        return;
      }
      focusedSearchResultItem.style.backgroundColor = "#fff";
      if (e.keyCode === 40 || e.keyCode === 38) {
        // console.log("focusedSearchResultItem", focusedSearchResultItem);
        if (e.keyCode === 40 && focusedSearchResultItem.nextElementSibling) {
          focusedSearchResultItem = focusedSearchResultItem.nextElementSibling;
        }
        else if (e.keyCode === 38 && focusedSearchResultItem.previousElementSibling) {
          focusedSearchResultItem = focusedSearchResultItem.previousElementSibling;
        }
        focusedSearchResultItem.style.backgroundColor = "#f0f0f0";
        focusedSearchResultRef.current = focusedSearchResultItem
      }
    }
  }

  return (
    <>
      <div className={searchBarStyles.searchBar}>
        {/* <FaSearch className={searchBarStyles.searchIcon} /> */}
        {/* <IoArrowBackSharp className={searchBarStyles.backIcon} /> */}
        <IoMdArrowRoundBack
          className={searchBarStyles.backIcon}
          onClick={handleBackClick}
        />
        <input
          id="search-accordion-input"
          type="text"
          placeholder="Search Test"
          autoComplete="off"
          onChange={(e) => handleSearchValueChange(e.target.value)}
          value={searchValue}
          className={searchBarStyles.searchText}
          autoFocus
          onKeyDown={handleSearchResultFocus}
        />
        {searchValue
          ? <IoCloseCircleOutline
            className={searchBarStyles.searchCloseIcon}
            // onClick={handleAccordionClose}
            onClick={() => {
              // document.getElementById("search-accordion-input").value = "";
              handleSearchValueChange("")
            }}
          />
          : <FaSearch className={searchBarStyles.searchIcon} />}
      </div>
      {searchValue !== "" && packagesList.length !== 0 &&
        <div
          id="search-results-container"
          className={`${searchBarStyles.searchResultContainer} ${searchBarStyles.slideInTop}`}
          ref={focusedSearchResultRef}
        >
          {packagesList.map((resultPackage, index) => {
            if (index < 6) {
              return (
                <SearchResultBar
                  key={index}
                  packageName={resultPackage.name}
                  slug={resultPackage.slug}
                  focusedSearchResultRef={focusedSearchResultRef}
                  handleAccordionClose={handleAccordionClose}
                  handleAddressModalOpen={handleAddressModalOpen}
                  onOpenModal={onOpenModal}
                />
              )
            }
          })}
        </div>
      }
    </>
  )
}

export default SearchBar;